import { Link } from "react-router-dom";
import { Grid, Stack, Typography } from "@mui/material";
import { Loader } from "../../components/Loader";
import CollectionCard from "../../components/Card/Collection";
import { usePredictiveSearchQuery } from "../../generated/storefront";
import { truncateTwoLinesStyles } from "../../state/constants";

const OtherTab = ({ searchQs }: { searchQs: string }) => {
  const { data: predictiveSearchData, loading } = usePredictiveSearchQuery({
    variables: { query: searchQs },
  });
  const articles = (predictiveSearchData?.predictiveSearch?.articles || []).filter((article) => article.image);
  const collections = (predictiveSearchData?.predictiveSearch?.collections || []).filter((collection) => collection.image);

  return (
    <>
      {loading ? (
        <Loader />
      ) : articles.length > 0 || collections.length > 0 ? (
        <Stack gap={3} width="100%">
          <Grid container spacing={{ xs: 1, md: 2 }} rowGap={{ xs: 4, md: 6 }}>
            {articles.map((article) => (
              <Grid item xs={12 / 2} md={12 / 4} key={article.id}>
                <Stack gap={2} height="100%">
                  <Link to={`/goodnews/${article.handle}`}>
                    <img src={article.image?.url} alt={article.title} width="100%" height="100%" style={{ objectFit: "cover" }} />
                    <Typography variant="body2" style={truncateTwoLinesStyles} minHeight={40}>
                      {article.title}
                    </Typography>
                  </Link>
                </Stack>
              </Grid>
            ))}

            {collections.map((collection) => (
              <Grid item xs={12 / 2} md={12 / 4} key={collection.id}>
                <CollectionCard collection={collection} imageHeight="100%" />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ) : (
        <Typography variant="h3" align="center">
          No blogs or collections found for "{searchQs}"
        </Typography>
      )}
    </>
  );
};

export default OtherTab;
